import { ColDef } from 'ag-grid-community';
import { CellTypes } from '../../services/vehicles';
import { VehicleChangeHistory } from '../../types/vehicle';

interface VehicleChangeHistoryColDef<T> extends ColDef<T> {
  type: keyof typeof CellTypes;
  field: any;
  hide?: boolean;
}

const determineOperationType = (bulkOperationFlag: any) => {
  if (typeof bulkOperationFlag !== 'boolean' && bulkOperationFlag?.includes('(')) {
    return bulkOperationFlag;
  }
  if (typeof bulkOperationFlag !== 'boolean' || bulkOperationFlag === undefined || bulkOperationFlag == null) {
    return '-';
  }
  if (bulkOperationFlag === false) {
    return 'Single';
  }
  return 'Bulk';
};

const formatRequestorName = (requestorId: string) => {
  return requestorId || '';
};

const formatDateString = (dateString: string) => {
  if (dateString) {
    const dateValue = new Date(dateString);
    return new Intl.DateTimeFormat('en', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })?.format(dateValue);
  }
  if (dateString?.indexOf('null') === 0) {
    return dateString;
  }
  return '';
};

const columnDefs: VehicleChangeHistoryColDef<VehicleChangeHistory>[] = [
  {
    headerName: 'Batch Number',
    field: 'batchNumber',
    sortable: true,
    width: 140,
    filter: 'agNumberColumnFilter',
    type: 'Plain',
    hide: false,
  },
  {
    headerName: 'VIN',
    field: 'VIN',
    sortable: true,
    width: 160,
    filter: 'agTextColumnFilter',
    type: 'Plain',
    hide: false,
  },
  {
    headerName: 'Model Year',
    field: 'vehiclDetails.modelYear',
    sortable: true,
    width: 150,
    filter: 'agTextColumnFilter',
    type: 'Plain',
    hide: false,
  },
  {
    headerName: 'Previous Category',
    field: 'previousCategory',
    width: 200,
    sortable: true,
    type: 'Plain',
    hide: false,
  },
  {
    headerName: 'Previous Sub Category',
    field: 'previousSubCategory',
    width: 200,
    sortable: true,
    type: 'Plain',
    hide: false,
  },
  {
    headerName: 'New Category',
    field: 'newCategory',
    sortable: true,
    type: 'Plain',
    width: 200,
    hide: false,
  },
  {
    headerName: 'New Sub Category',
    field: 'newSubCategory',
    sortable: true,
    type: 'Plain',
    width: 200,
    hide: false,
  },
  {
    headerName: 'Changed By',
    field: 'requestor',
    valueFormatter: (params: any) => formatRequestorName(params?.value),
    sortable: true,
    width: 150,
    type: 'Plain',
    hide: false,
  },
  {
    headerName: 'Changed At',
    field: 'createdAt',
    valueFormatter: (params: any) => formatDateString(params?.value),
    sortable: true,
    type: 'Plain',
    width: 150,
    hide: false,
  },
  {
    headerName: 'Change Reason',
    field: 'comments',
    type: 'Plain',
    width: 250,
    hide: false,
  },
  {
    headerName: 'Operation Type',
    field: 'bulk',
    valueFormatter: (params: any) => determineOperationType(params?.value),
    sortable: true,
    type: 'Plain',
    width: 150,
  },
  {
    headerName: 'Model',
    field: 'vehiclDetails.carModel',
    sortable: true,
    type: 'Plain',
    width: 150,
  },
  {
    headerName: 'Variant',
    field: 'vehiclDetails.variant',
    sortable: true,
    type: 'Plain',
    width: 150,
  },
  {
    headerName: 'Vehicle Stage',
    field: 'vehiclDetails.vehicleStage',
    sortable: true,
    type: 'Tag',
    width: 150,
  },
  {
    headerName: 'Vehicle Substage',
    field: 'vehiclDetails.vehicleSubStage',
    sortable: true,
    type: 'Plain',
    width: 150,
  },
];

export const metaData = {
  module: 'Vehicle Change History',
  subModule: 'Grid',
  columnDefs,
  filterDetails: [
    'Batch Number',
    'VIN',
    'Requestor',
    'Previous Category',
    'New Category',
    'Previous SubCategory',
    'New SubCategory',
    'Operation Type',
    'Changed At',
  ],
  manageColumns: [
    'Batch Number',
    'VIN',
    'Requestor',
    'Previous Category',
    'New Category',
    'Previous SubCategory',
    'New SubCategory',
    'Operation Type',
    'Changed At',
  ],
  langCode: 'en-us',
};
